// extracted by mini-css-extract-plugin
module.exports = {"tableDragHandle":"TableDragHandle_tableDragHandle__-SLEG","wrapper":"TableDragHandle_wrapper__16trB","iconDrag":"TableDragHandle_iconDrag__3Kukx"};